import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import DownloadLabel from '../../components/common/DownloadLabel/Download';
import ExportLabel from '../../components/common/ExportLabel/Export';
import './AddRecipient.css';
import LargeDetailBox from '../../components/common/DetailBox/LargeDetailBox';
import axios from 'axios';
import './RecipientDetail.css';
import { baseurl } from '../../api';
import authenticatedAxios from '../../authenticatedAxios';

// const DetailRecipient = () => {
//   const location = useLocation();
//   const { item } = location.state || {};
//   const navigate = useNavigate();
//   const [users, setUsers] = useState([]);
//   const [companies, setCompanies] = useState([]);
//   const [activeButton, setActiveButton] = useState('Companies');
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filteredCompanies, setFilteredCompanies] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);

//   useEffect(() => {
//     if (item?.recipients) {
//       fetchUserAndOrganizationDetails(item.recipients);
//     }
//   }, [item]);
  
//   const fetchUserAndOrganizationDetails = async (recipientIds) => {
//     try {
//       setLoading(true);
  
//       // Fetch all users and organizations first
//       const [usersResponse, companiesResponse] = await Promise.all([
//         authenticatedAxios.get(`${baseurl}accounts/users/organizational/`),
//         authenticatedAxios.get(`${baseurl}organization/`),
//       ]);

//       const allUsersData = usersResponse.data.data;
//       const allCompaniesData = companiesResponse.data.data;

//       // Filter users based on the recipients
//       const filteredUsers = allUsersData.filter(user => recipientIds.includes(user.id));
      
//       const userNames = filteredUsers.map(user => ({
//         id: user.id,
//         name: user.full_name || 'Unnamed User'
//       }));

//       const uniqueOrganizations = Array.from(
//         new Set(
//           filteredUsers
//             .filter(user => user.organization) 
//             .map(user => user.organization.id)
//         )
//       ).map(orgId => {
//         const organization = filteredUsers.find(user => user.organization && user.organization.id === orgId).organization;
//         return {
//           id: organization.id,
//           name: organization.name || 'Unnamed Organization'
//         };
//       });
  
//       setUsers(userNames);
//       setCompanies(uniqueOrganizations);
  
//     } catch (error) {
//       console.error('Error fetching user and organization details:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditClick = () => {
//     navigate('/edit-recipient', { state: { item } });
//   };

//   const handleButtonClick = (buttonType) => setActiveButton(buttonType);

//   return (
//     <div className='whole-container'>
//       <div className='top-heading'>
//         <PageHeader pageName="Notification/Recipient Groups" nestedpageName={item?.name}  linkTo="/recipient-groups" />   

//         <div className='export-container'>
//           <DownloadLabel />
//           <ExportLabel />
//         </div>
//       </div>

//       <div className='recipient-top-container add-input-box-container'>
//         <div className='heading-recipient-detail'>
//           <h1 className='fts-18 black common-text ftw-5'>Recipient Group</h1>
//           <div>
//             <button className='recipient-edit-button common-text fts-15 ftw-4 blue' onClick={handleEditClick}>
//               Edit
//             </button>
//           </div>
//         </div>
//         <LargeDetailBox label="Group Name" value={item?.name} />
//         <LargeDetailBox label="Created Date" value={item?.created_time} />
//       </div>

//       <div className='recipient-top-container'>
//         <div className='recipient-heading'>
//           <span className='fts-18 black common-text ftw-5'>Recipients</span>

//         </div>
//         <div className='selected-company-and-users'>
//           <div className='recipint-detail-buttons-and-search buttons-and-search'>
//             <div className='recipint-detail-buttons buttons-recipient'>
//               <a
//                 className='common-text fts-15 fts-4 black'
//                 onClick={() => handleButtonClick('Companies')}
//                 style={{
//                   borderBottom: activeButton === 'Companies' ? '2px solid #094C80' : 'none',
//                 }}
//               >
//                 Companies
//               </a>
//               <a
//                 className='common-text fts-15 fts-4 black'
//                 onClick={() => handleButtonClick('Users')}
//                 style={{
//                   borderBottom: activeButton === 'Users' ? '2px solid #094C80' : 'none',
//                 }}
//               >
//                 User Accounts
//               </a>

//             </div>
//             <div className="recipient-detail-search search-recipient-container">
//                   <input
//                     className="search-recipient"
//                     label="Search Companies or User Accounts"
//                     placeholder='Search Customer'
//                   />
//                   <div className="">
//                     <svg className='search-recipient-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M11.8889 11.8889L15 15M1 7.22222C1 8.87246 1.65555 10.4551 2.82245 11.622C3.98934 12.7889 5.57199 13.4444 7.22222 13.4444C8.87246 13.4444 10.4551 12.7889 11.622 11.622C12.7889 10.4551 13.4444 8.87246 13.4444 7.22222C13.4444 5.57199 12.7889 3.98934 11.622 2.82245C10.4551 1.65555 8.87246 1 7.22222 1C5.57199 1 3.98934 1.65555 2.82245 2.82245C1.65555 3.98934 1 5.57199 1 7.22222Z" stroke="#424242" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
//                     </svg>
//                   </div>
//                 </div>
//           </div>

//           {loading ? (
//             <div className='selected-companies'>
//               <span className='common-text fts-15 ftw-4 black recipient-span'>
//                 Loading...
//               </span>
//             </div>
//           ) : (
//             <>
//               {activeButton === 'Companies' && (
//                 <div className='selected-companies'>
//                   <div className='company-name-container'>
//                     <span className="company-name-span common-text fts-15 ftw-4 lt-gray ">Company Name</span>
//                   </div>
//                   {companies.length > 0 ? (
//                     companies.map((company) => (
//                       <span key={company.id} className='common-text fts-15 ftw-4 black recipient-span'>
//                         {company.name}
//                       </span>
//                     ))
//                   ) : (
//                     <span className='common-text fts-15 ftw-4 black recipient-span'>
//                     </span>
//                   )}

//                 </div>
//               )}

//               {activeButton === 'Users' && (
//                 <div className='selected-companies'>
//                   <div className='company-name-container'>
//                     <span className="company-name-span common-text fts-15 ftw-4 lt-gray ">User Name</span>
//                   </div>
//                   {users.length > 0 ? (
//                     users.map((user) => (
//                       <span key={user.id} className='common-text fts-15 ftw-4 black recipient-span'>
//                         {user.name}
//                       </span>
//                     ))
//                   ) : (
//                     <span className='common-text fts-15 ftw-4 black recipient-span'>
//                       No users found
//                     </span>
//                   )}
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DetailRecipient;
const DetailRecipient = () => {
  const location = useLocation();
  const { item } = location.state || {};
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [activeButton, setActiveButton] = useState('Companies');
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    if (item?.recipients) {
      fetchUserAndOrganizationDetails(item.recipients);
    }
  }, [item]);
  
  // Update filtered data whenever search term or original data changes
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredCompanies(companies);
      setFilteredUsers(users);
    } else {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      
      setFilteredCompanies(
        companies.filter(company => 
          company.name.toLowerCase().includes(lowerCaseSearchTerm)
        )
      );
      
      setFilteredUsers(
        users.filter(user => 
          user.name.toLowerCase().includes(lowerCaseSearchTerm)
        )
      );
    }
  }, [searchTerm, companies, users]);
  
  const fetchUserAndOrganizationDetails = async (recipientIds) => {
    try {
      setLoading(true);
  
      // Fetch all users and organizations first
      const [usersResponse, companiesResponse] = await Promise.all([
        authenticatedAxios.get(`${baseurl}accounts/users/organizational/`),
        authenticatedAxios.get(`${baseurl}organization/`),
      ]);

      const allUsersData = usersResponse.data.data;
      const allCompaniesData = companiesResponse.data.data;

      // Filter users based on the recipients
      const filteredUsers = allUsersData.filter(user => recipientIds.includes(user.id));
      
      const userNames = filteredUsers.map(user => ({
        id: user.id,
        name: user.full_name || 'Unnamed User'
      }));

      const uniqueOrganizations = Array.from(
        new Set(
          filteredUsers
            .filter(user => user.organization) 
            .map(user => user.organization.id)
        )
      ).map(orgId => {
        const organization = filteredUsers.find(user => user.organization && user.organization.id === orgId).organization;
        return {
          id: organization.id,
          name: organization.name || 'Unnamed Organization'
        };
      });
  
      setUsers(userNames);
      setCompanies(uniqueOrganizations);
      setFilteredUsers(userNames);
      setFilteredCompanies(uniqueOrganizations);
  
    } catch (error) {
      console.error('Error fetching user and organization details:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = () => {
    navigate('/edit-recipient', { state: { item } });
  };

  const handleButtonClick = (buttonType) => setActiveButton(buttonType);
  
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className='whole-container'>
      <div className='top-heading'>
        <PageHeader pageName="Notification/Recipient Groups" nestedpageName={item?.name}  linkTo="/recipient-groups" />   

        <div className='export-container'>
          <DownloadLabel />
          <ExportLabel />
        </div>
      </div>

      <div className='recipient-top-container add-input-box-container'>
        <div className='heading-recipient-detail'>
          <h1 className='fts-18 black common-text ftw-5'>Recipient Group</h1>
          <div>
            <button className='recipient-edit-button common-text fts-15 ftw-4 blue' onClick={handleEditClick}>
              Edit
            </button>
          </div>
        </div>
        <LargeDetailBox label="Group Name" value={item?.name} />
        <LargeDetailBox label="Created Date" value={item?.created_time} />
      </div>

      <div className='recipient-top-container'>
        <div className='recipient-heading'>
          <span className='fts-18 black common-text ftw-5'>Recipients</span>
        </div>
        <div className='selected-company-and-users'>
          <div className='recipint-detail-buttons-and-search buttons-and-search'>
            <div className='recipint-detail-buttons buttons-recipient'>
              <a
                className='common-text fts-15 fts-4 black'
                onClick={() => handleButtonClick('Companies')}
                style={{
                  borderBottom: activeButton === 'Companies' ? '2px solid #094C80' : 'none',
                }}
              >
                Companies
              </a>
              <a
                className='common-text fts-15 fts-4 black'
                onClick={() => handleButtonClick('Users')}
                style={{
                  borderBottom: activeButton === 'Users' ? '2px solid #094C80' : 'none',
                }}
              >
                User Accounts
              </a>
            </div>
            <div className="recipient-detail-search search-recipient-container">
              <input
                className="search-recipient"
                label="Search Companies or User Accounts"
                placeholder='Search Customer'
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <div className="">
                <svg className='search-recipient-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.8889 11.8889L15 15M1 7.22222C1 8.87246 1.65555 10.4551 2.82245 11.622C3.98934 12.7889 5.57199 13.4444 7.22222 13.4444C8.87246 13.4444 10.4551 12.7889 11.622 11.622C12.7889 10.4551 13.4444 8.87246 13.4444 7.22222C13.4444 5.57199 12.7889 3.98934 11.622 2.82245C10.4551 1.65555 8.87246 1 7.22222 1C5.57199 1 3.98934 1.65555 2.82245 2.82245C1.65555 3.98934 1 5.57199 1 7.22222Z" stroke="#424242" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </div>

          {loading ? (
            <div className='selected-companies'>
              <span className='common-text fts-15 ftw-4 black recipient-span'>
                Loading...
              </span>
            </div>
          ) : (
            <>
              {activeButton === 'Companies' && (
                <div className='selected-companies'>
                  <div className='company-name-container'>
                    <span className="company-name-span common-text fts-15 ftw-4 lt-gray ">Company Name</span>
                  </div>
                  {filteredCompanies.length > 0 ? (
                    filteredCompanies.map((company) => (
                      <span key={company.id} className='common-text fts-15 ftw-4 black recipient-span'>
                        {company.name}
                      </span>
                    ))
                  ) : (
                    <span className='common-text fts-15 ftw-4 black recipient-span'>
                      No companies found
                    </span>
                  )}
                </div>
              )}

              {activeButton === 'Users' && (
                <div className='selected-companies'>
                  <div className='company-name-container'>
                    <span className="company-name-span common-text fts-15 ftw-4 lt-gray ">User Name</span>
                  </div>
                  {filteredUsers.length > 0 ? (
                    filteredUsers.map((user) => (
                      <span key={user.id} className='common-text fts-15 ftw-4 black recipient-span'>
                        {user.name}
                      </span>
                    ))
                  ) : (
                    <span className='common-text fts-15 ftw-4 black recipient-span'>
                      No users found
                    </span>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailRecipient;